import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Tooltip from 'material-ui/Tooltip';
import IconButton from 'material-ui/IconButton';
import AddIcon from 'material-ui-icons/Add';
import FilterListIcon from 'material-ui-icons/FilterList';

const toolbarStyles = theme => ({
    root: {
      paddingRight: 2,
    },
    highlight:
      theme.palette.type === 'light'
        ? {
            color: theme.palette.secondary.A700,
            backgroundColor: theme.palette.secondary.A100,
          }
        : {
            color: theme.palette.secondary.A100,
            backgroundColor: theme.palette.secondary.A700,
          },
    spacer: {
      flex: '1 1 100%',
    },
    actions: {
      color: theme.palette.text.secondary,
    },
    title: {
      flex: '0 0 auto',
    },
});

let EnhancedTableToolbar = props => {
    const { classes,title,addNewOnclick } = props;
  
    return (
      <Toolbar
        className={classNames(classes.root)}
      >
        <div className={classes.title}>
           <h4>{title}</h4>
        </div>
        <div className={classes.spacer} />
        <div className={classes.actions}>
           {addNewOnclick?(
            <Tooltip title="Add New">
              <IconButton aria-label="Add" onClick={addNewOnclick} >
                <AddIcon />
              </IconButton>
            </Tooltip>
           ):null}
        </div>
      </Toolbar>
    );
};
  
EnhancedTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    title: PropTypes.string,
    addNewOnclick: PropTypes.func
};
  
EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

export default EnhancedTableToolbar;


// WEBPACK FOOTER //
// ./src/components/MaterialUi/DataTable/EnhancedTableToolbar.js